import { addEasing } from "@tsparticles/engine";
export async function loadEasingQuadPlugin() {
    addEasing("ease-in-quad", (value) => value ** 2);
    addEasing("ease-out-quad", (value) => 1 - (1 - value) ** 2);
    addEasing("ease-in-out-quad", (value) => (value < 0.5 ? 2 * value ** 2 : 1 - (-2 * value + 2) ** 2 / 2));
    await Promise.resolve();
}
